import enIcon from 'assets/uk.svg'
import roIcon from 'assets/romania.svg'
import bgIcon from 'assets/bulgaria.svg'
import useLanguageSelect from 'features/common/hooks/useLanguageSelect'
import {useTranslation} from 'react-i18next'

const languages = [
    {
        value: 'bg',
        label: 'BG',
        icon: bgIcon,
    },
    {
        value: 'en',
        label: 'EN',
        icon: enIcon,
    },
    {
        value: 'ro',
        label: 'RO',
        icon: roIcon,
    },
]
const LanguageSelect = () => {
    const {t} = useTranslation()
    const {language, onChangeLanguage} = useLanguageSelect()
    return (
        <div className="flex flex-col items-center gap-2 text-yellow-40">
            <div>{t('AUTH_SELECT_LANGUAGE')}</div>
            <div className="flex gap-10">
                {languages.map((l) => (
                    <div
                        key={l.value}
                        className={`flex flex-col items-center justify-center gap-1
                            ${l.value === language ? 'font-bold' : ''}
                        `}
                        onClick={() => onChangeLanguage(l.value)}
                    >
                        <img src={l.icon} alt={l.value} className="h-10 w-10" />
                        <div>{l.label}</div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default LanguageSelect
